import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import Zone from "@insite/client-framework/Components/Zone";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getJobQuoteState } from "@insite/client-framework/Store/Data/JobQuotes/JobQuotesSelector";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import loadJobQuoteIfNeeded from "@insite/client-framework/Store/Pages/RfqJobQuoteDetails/Handlers/LoadJobQuoteIfNeeded";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import { PageErrorWrapper } from "@insite/content-library/Components/PageErrorWrapper";
import Page from "@insite/mobius/Page";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const { search } = getLocation(state);
    const parsedQuery = parseQueryString<{ jobQuoteId?: string }>(search);
    const jobQuoteId = parsedQuery.jobQuoteId;

    return {
        jobQuoteId,
        jobQuoteState: getJobQuoteState(state, jobQuoteId),
    };
};

const mapDispatchToProps = {
    loadJobQuoteIfNeeded,
};

export interface RfqJobQuoteDetailsPageStyles {
    loadFailedWrapper?: InjectableCss;
    loadFailedText?: TypographyPresentationProps;
}

export const rfqJobQuoteDetailsPageStyles: RfqJobQuoteDetailsPageStyles = {
    loadFailedWrapper: {
        css: css`
            display: flex;
            height: 200px;
            justify-content: center;
            align-items: center;
            background-color: ${getColor("common.accent")};
        `,
    },
    loadFailedText: { weight: "bold" },
};

type Props = PageProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const RfqJobQuoteDetailsPage = ({ id, jobQuoteId, jobQuoteState, loadJobQuoteIfNeeded }: Props) => {
    useEffect(() => {
        if (jobQuoteId && !jobQuoteState.isLoading && !jobQuoteState.errorStatusCode) {
            loadJobQuoteIfNeeded({ jobQuoteId });
        }
    }, [jobQuoteId, jobQuoteState.isLoading, jobQuoteState.value]);

    return (
        <Page>
            <PageErrorWrapper
                loadFailedTextTestSelector="rfqJobQuoteDetails_notFound"
                value={jobQuoteState}
                extendedStyles={rfqJobQuoteDetailsPageStyles}
                notFoundMessage={siteMessage("JobQuote_NotFound")}
            >
                <Zone contentId={id} zoneName="Content" />
            </PageErrorWrapper>
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RfqJobQuoteDetailsPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "RfqJobQuoteDetailsPage" instead of this constant.
 */
export const RfqJobQuoteDetailsPageContext = "RfqJobQuoteDetailsPage";
